import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { RouterModule } from '@angular/router';

import { ClientBrandingApiService } from './client-branding-api.service';
import { ClientBrandingService } from './client-branding.service';
import { CoreModule } from '../core/core.module';
import { ClientBrandingStylingDirective } from './client-branding-styling.directive';
import { LogoComponent } from './logo/logo.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    RouterModule,
    RouterLink,
    ClientBrandingStylingDirective,
    LogoComponent,
  ],
  providers: [ClientBrandingApiService, ClientBrandingService],
  exports: [ClientBrandingStylingDirective, LogoComponent],
})
export class ClientBrandingModule {}
